import { render } from "./Story.vue?vue&type=template&id=1add8aa8&scoped=true"
import script from "./Story.vue?vue&type=script&lang=js"
export * from "./Story.vue?vue&type=script&lang=js"

import "./Story.vue?vue&type=style&index=0&id=1add8aa8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1add8aa8"]])

export default __exports__